import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { getMemberActionIsRead } from "../../actions/memberActions";
import { getMember, sendCodeEmail } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import './account.css';

class AccountPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModalSendCode: "",
      showModalBackdrop: "",
    };

    this.handleCloseModalSendCode = this.handleCloseModalSendCode.bind(this);
    this.sendCodeEmail = this.sendCodeEmail.bind(this);
  }
  
  componentDidMount = () => {
    this.props.getMemberActionIsRead();
    this.props.getMember();
  };

  componentDidUpdate(prevProps) {
    if (this.props.code !== prevProps.code) {
      if(this.props.code.msg && this.props.code.msg === "Send Code OK") {
        this.setState({ showModalSendCode: "show", showModalBackdrop: "modal-backdrop show" });
      }
    }
  };

  handleCloseModalSendCode() {
    this.setState({ showModalSendCode: "", showModalBackdrop: "" });
  }

  sendCodeEmail(e) {
    e.preventDefault();
    this.props.sendCodeEmail();
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead, member } = this.props;
    const {showModalSendCode, showModalBackdrop } = this.state;

    let formGroup = {
      marginBottom: "25px", 
      display: "inline-flex"
    };

    let formLabel = {
      width: "6rem", 
      margin: "auto 0", 
      color: "#fff"
    };

    let formControl = {
      width: "300px"
    };

    if (window.innerWidth <= 480) {
      formControl.width = "250px";
    }

    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar isRead={isRead} />
          <aside className="colorlib-breadcrumbs">
            <div className="container">
            <div className="row">
              <div className="col-md-12 breadcrumbs text-center">
              <h2>個人資訊</h2>
              <p><span>personal information</span></p>
              </div>
            </div>
            </div>
          </aside>
          <div className="colorlib">
            <div className="container">
            <form>
              
              <div className="form-group" style={formGroup}>
                <label htmlFor="member_name" style={formLabel}>姓名</label>
                <input type="text" className="form-control" style={formControl} id="member_name" value={member.member_name || ''} disabled />
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="email" style={formLabel}>E-Mail</label>
                <input type="email" className="form-control" style={formControl} id="email" value={member.email} disabled />
                <a href="/members/change_email">變更</a>
                {member.email_verification === 0 && (
                <a href="" onClick={this.sendCodeEmail}>驗證</a>
                )}
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="mobile" style={formLabel}>手機</label>
                <input type="text" className="form-control" style={formControl} id="mobile" value={member.phone} disabled />
                {(!member.phone_update_time || moment().diff(moment(member.phone_update_time), 'days') > 90) && (
                <a href="/members/change_mobile">變更</a>
                )}
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="" style={formLabel}>密碼</label>
                <a href="/members/change_pwd">變更密碼</a> 
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="gender" style={formLabel}>性別</label>
                <input type="text" className="form-control" style={formControl} id="gender" value={member.gender==='x'?"中性":member.gender==='m'?"男":"女"} disabled />
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="birthday" style={formLabel}>生日</label>
                <input type="text" className="form-control" style={formControl} id="birthday" value={moment(member.birthday).format("YYYY-MM-DD") || ''} disabled />
              </div>

              <div className="form-group" style={formGroup}>
                <label htmlFor="area" style={formLabel}>居住地</label>
                <input type="text" className="form-control" style={formControl} id="area" value={member.area || ''} disabled />
              </div>

            </form>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModalSendCode}`} id="myModalSendCode" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" style={{width: "350px",margin: "250px auto"}}>
                    <div className="modal-content"> 
                        <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                            <h3>驗證信件已發送完成</h3>
                            <p>請到您的信箱啟動驗證信件，10分鐘有效</p>
                        </div>
                        <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModalSendCode}>關閉</button>
                        </div>
                    </div>
                </div>
            </div>
          </div>

          <Footer showAgreement={true} />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

AccountPage.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  getMember: PropTypes.func.isRequired,
  sendCodeEmail: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  member: state.auth.member_data,
  code: state.auth.sendCodeEmailResult,
});

export default connect(mapStateToProps, { getMember, sendCodeEmail, getMemberActionIsRead })(AccountPage);